import React from "react";
import Button from "../../../../../components/button/button.jsx";
import { Modal } from "../../../../../components/modal/modal.jsx";

const AlarmArmDisarmModal = ({ open, setOpen, description, alarmStatus, loading, onArmDisarm }) => {
    if (!open) return null;

    const { armed, partitioningEnabled, accounts = [], mainAccount } = alarmStatus || {};

    return (
        <Modal open={open} setOpen={setOpen} centered size="md" backdrop="static" keyboard={false} title={description} className={"w-3/12"}>
            <Modal.Body className="p-3 space-y-3">
                { loading && (
                    <div className="text-center text-sm text-gray-500">
                        Carregando...
                    </div>
                )}

                { !loading && alarmStatus && (
                    <>
                        { partitioningEnabled && (
                            <div className="space-y-2">
                                { accounts.map(acc => (
                                    <div key={`${acc.account}-${acc.partition}`} className="flex justify-between items-center border border-gray-200 p-2 rounded">
                                        <div className="text-sm">
                                            {acc.account} — Partição {acc.partition} —{" "}
                                            <strong>{acc.armed ? "Armado" : "Desarmado"}</strong>
                                        </div>

                                        { acc.armed ? (
                                            <Button target="danger" onClick={() => onArmDisarm("disarming", acc.partition, acc.account)}>Desarmar</Button>
                                        ) : (
                                            <Button target="primary" onClick={() => onArmDisarm("arming", acc.partition, acc.account)}>Armar</Button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}
            </Modal.Body>

            <Modal.Footer className="p-2">
                <div className="flex gap-2 start w-full">
                    { armed ? (
                        <Button target="danger" onClick={() => onArmDisarm("disarming", "all")}>Desarmar geral</Button>
                    ) : (
                        <Button target="primary" onClick={() => onArmDisarm("arming", "all")}>Armar geral</Button>
                    )}
                </div>

                <Button target="secondary" onClick={setOpen}>Cancelar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AlarmArmDisarmModal;
